/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "95b00288a4c4f8958dab8ba21ff0f8fd10b0bace";
